<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Audit Pelunasan</h5>
            </template>
            <div class="big-filter-label filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="9">
                        <b-form-group class="form-inline" label-for="filterNoFaktur" label="No. Faktur">
                            <b-form-input
                                v-model="input.filterNoFaktur" name="filterNoFaktur"
                                type="search"
                                id="filterNoFaktur"
                                placeholder="Masukkan no. faktur"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterCabang" label="Cabang">
                            <multiselect v-model="input.filterCabang" :options="cabangOption" :internal-search="true"
                                :allow-empty="false" deselect-label="" select-label="" label="name" track-by="id"
                                placeholder="-- Pilih Cabang --" />
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterStatus" label="Status">
                            <b-form-select v-model="input.filterStatus" id="filterStatus" name="tipe" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>-- Pilih Tipe --</b-form-select-option>
                                    <b-form-select-option :value="1">Pending SBG Awal</b-form-select-option>
                                    <b-form-select-option :value="2">Pending Berkas Pelunasan</b-form-select-option>
                                    <b-form-select-option :value="10">Menunggu Pelunasan</b-form-select-option>
                                    <b-form-select-option :value="99">Lengkap</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterTipePelunasan" label="Tipe Pelunasan">
                            <b-form-select v-model="input.filterTipePelunasan" id="filterTipePelunasan" name="tipe" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>-- Pilih Tipe --</b-form-select-option>
                                    <b-form-select-option :value="1">Nasabah + SBG</b-form-select-option>
                                    <b-form-select-option :value="2">Nasabah + Nota Hilang</b-form-select-option>
                                    <b-form-select-option :value="3">Pelunasan Diwakilkan + SBG</b-form-select-option>
                                    <b-form-select-option :value="4">Pelunasan Diwakilkan + Surat Kuasa PGI (Apabila SBG Hilang)</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>    
                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal Pelunasan">
                            <div class="d-flex search-input-wrapper">
                                <b-form-input
                                    v-model="input.filterStartDate" name="filterStartDate"
                                    id="filterDate"
                                    type="date"
                                ></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input
                                    v-model="input.filterEndDate" name="filterEndDate"
                                    type="date"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                                       
                    </b-col>
                    <b-col cols="12">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                                Search 
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="daftarPelunasan" 
                :fields="fields" 
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data gadai.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    <p class="mb-0">{{row.item.noFaktur}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.cabang}}</p>
                </template>
                <template v-slot:cell(jumlahPinjaman)="row">
                    <div class="text-right no-wrap">
                        <p class="mb-0" v-if="row.item.jumlahPinjaman !== null">Rp. {{$helper.addThousandSeparator(row.item.jumlahPinjaman)}} </p>
                        <p class="mb-0" v-else>{{$helper.addThousandSeparator(row.item.jumlahPinjaman)}} </p>                 
                    </div>
                </template>
                <template v-slot:cell(barang)="row">
                    <div v-if="row.item.jenisPinjaman == 'Kendaraan'">
                        <p class="mb-0">{{row.item.jenis}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                    </div>
                    <div v-else>
                        <p class="mb-0">{{row.item.tipe}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.jenis}} - {{row.item.merk}}</p>
                    </div>
                </template>
                <template v-slot:cell(tanggalPelunasan)="row">
                    <div v-if="row.item.tanggalPelunasan != null">
                        <div>{{$helper.changeDateFormat(row.item.tanggalPelunasan)}}</div>
                        <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalPelunasan)}}</div>
                    </div>
                    <div v-else>-</div>
                </template>
                <template v-slot:cell(status)="row">
                    <div v-if="row.item.status == 1">Pending SBG Awal</div>
                    <div v-if="row.item.status == 2">Pending Berkas Pelunasan</div>
                    <div v-if="row.item.status == 10">Menunggu Pelunasan</div>
                    <div v-if="row.item.status == 99">Lengkap</div>
                    <div class="smallText text-muted">Foto terupload : {{ row.item.photoCount }}</div>
                </template>
                <template v-slot:cell(tipePelunasan)="row">
                    <b-form-select-option v-if="row.item.tipePelunasan == 1">Nasabah + SBG</b-form-select-option>
                    <b-form-select-option v-if="row.item.tipePelunasan == 2">Nasabah + Nota Hilang</b-form-select-option>
                    <b-form-select-option v-if="row.item.tipePelunasan == 3">Pelunasan Diwakilkan + SBG</b-form-select-option>
                    <b-form-select-option v-if="row.item.tipePelunasan == 4">Pelunasan Diwakilkan + Surat Kuasa PGI (Apabila SBG Hilang)</b-form-select-option>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="gadaiViewBtn" @click="detail(row.item)">
                            <i class="fa fa-info"></i>
                        </b-button>        
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>

            <b-modal 
                id="modal-detail" 
                title="Detail Bukti" 
                no-close-on-esc no-close-on-backdrop
            >
               <div v-if="loadDetail">
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
               </div>
               <div v-else>
                    <div v-if="activeItem != null">
                        <p>
                            No. Faktur : {{ activeItem.noFaktur }} 
                        </p>
                        <p v-if="activeItem.notaHilangCode">
                            Kode Nota Hilang : {{ activeItem.notaHilangCode }} 
                        </p>
                        <div v-for="item of activeItem.evidences" class="my-2">
                           <strong>
                               {{ item.name }}
                           </strong> 
                            <div class="d-flex">
                                <b-button class="mr-2" v-if="item.path != null" variant="cancelBtn" @click="viewFoto(item)">
                                    Lihat Foto
                                </b-button>
                                <p v-else>Bukti tidak diupload</p>
                            </div>
                        </div>
                    </div>
               </div>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="pgiBtn" name="cancelAjukanAngsuranSajaBtn" @click="cancel()">
                        Tutup
                    </b-button>
                </template>
            </b-modal>

            <b-modal id="modal-preview-foto" size="xl" :title="activeFotoPreview.name">
                <div v-if="activeItem">
                    No. Faktur : {{ activeItem.noFaktur }} 
                </div>
                <div class="my-2">
                    Oleh : {{ activeFotoPreview.createdBy }} , {{ $helper.changeDateFormat(activeFotoPreview.createdAt) }} {{
                        $helper.changeDateFormatGetHour(activeFotoPreview.createdAt) }}
                </div>
                <div class="modal-foto-wrapper">
                    <img :src="activeFotoPreview.path" alt="Foto">
                </div>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                        Close
                    </b-button>
                </template>
            </b-modal>

        </b-card>
    </div>
</template>

<script>
export default {
    name: 'daftar-gadai',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterNoFaktur: null,
                filterTipePelunasan: null,
                filterStatus: null,
                filterCabang: null,
                filterStartDate: null,
                filterEndDate: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur"},
                { key: "Barang", label: "Barang" },
                { key: "jumlahPinjaman", label: "Jumlah Pinjaman"},
                { key: "status", label: "Status"},
                { key: "tipePelunasan", label: "Tipe Pelunasan"},
                { key: "tanggalPelunasan", label: "Tanggal Pelunasan"},
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            activeItem: null,
            cabangOption:[],
            daftarPelunasan: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            cabangId: '',
            loading: false,
            query: "",

            loadDetail: false,
            activeFotoPreview: '',
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){

            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.cabangId = this.$helper.getCabangId()
            this.query = this.query+"&cabangId="+this.cabangId
            
        	let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            let getPelunasan = this.$axios.get("audit-pelunasan/"+this.query).then(response => {
                this.daftarPelunasan = response.data.data
                this.updateTotalItem(response.data.total)
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getPelunasan, getCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
                this.toggleBusy()
            })
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getPelunasan(){
            this.toggleBusy()
            this.daftarPelunasan = []
            this.cabangId = this.$helper.getCabangId()

            if (this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.filterTipePelunasan != null) this.query = this.query + "&filterTipePelunasan=" + this.input.filterTipePelunasan
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.input.filterCabang != null) this.query = this.query + "&filterCabang=" + this.input.filterCabang.id
            if (this.input.filterStartDate != null) this.query = this.query + "&filterStartDate=" + this.input.filterStartDate
            if (this.input.filterEndDate != null) this.query = this.query + "&filterEndDate=" + this.input.filterEndDate
            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.query += "&cabangId="+this.cabangId

            this.$axios.get("audit-pelunasan/"+this.query).then(response => {
                this.daftarPelunasan = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        detail(item){

            this.loadDetail = true
            this.$bvModal.show('modal-detail')
            
            this.$axios.get("audit-pelunasan/detail?evidenceId="+item.id).then(response => {
                this.activeItem = response.data
                this.activeItem.noFaktur = item.noFaktur
                this.loadDetail = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.loadDetail = false
                this.$bvModal.hide('modal-detail')
            })

        },

        viewFoto(item){
            this.activeFotoPreview = item
            this.$bvModal.show("modal-preview-foto")
        },
        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getPelunasan()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getPelunasan()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy == "tanggalPelunasan"){
                this.input.sortBy = "createdAt"
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }else if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterCabang = null
            this.input.filterNoFaktur = null
            this.input.filterTipePelunasan = null
            this.input.filterStatus = null
            this.input.filterStartDate = null
            this.input.filterEndDate = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getPelunasan()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
        
            this.loading = true
            this.getPelunasan()
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        getDaftarBarangHilang(){
            this.$axios.get("gadai/barang-hilang-allowed").then(response => {
                if(response.data.id == 0){
                    this.$helper.toastErr(this, "Tidak memiliki akses untuk melihat daftar barang hilang!")
                }else{
                    this.$router.push({path: `${this.$route.path}/barang-hilang`})
                }
            })
        }
    },

    created(){
        this.init()
    }
}
</script>
